import React, { useEffect, useState } from "react";
import "./category.scss";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  IconButton,
  InputLabel,
} from "@mui/material";

// Icons
import { IoIosAdd } from "react-icons/io";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

// Import Image
import { Link } from "react-router-dom";
import TwoBreadcrumb from "../../components/breadcrumbs/TwoBreadcrumb";
import categoryStore from "../../stores/categoryStore";
import snackbarStore from "../../stores/snackbarStore";
import SnackbarAlert from "../../components/snackbarAlert/snackbarAlert";
import CategoryCard from "../../components/categoryCard/CategoryCard";
import sidebarActivePage from "../../stores/sidebarActivePage";

const Category = () => {
  const CategoryStore = categoryStore();
  const SnackbarStore = snackbarStore();
  const SidebarActivePage = sidebarActivePage();

  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [isLoadingItemId, setIsLoadingItemId] = useState("");

  const [searchValue, setSearchValue] = useState("");
  const [searchValueCall, setSearchValueCall] = useState(false);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    SidebarActivePage.setIsActive({ setPage: "Category" });
    await CategoryStore.fetchCategory();
    if (SnackbarStore.massage !== "") {
      SnackbarStore.setIsOpen({ value: true });
    }
    setSearchValueCall(true);
  };

  useEffect(() => {
    if (searchValueCall) {
      /* for api */
      // if (searchValue !== "") {
      //   CategoryStore.SearchCategory({ categoryName: searchValue });
      // } else {
      //   CategoryStore.fetchCategory();
      // }
      /* for api */

      CategoryStore.SearchCategory({ categoryName: searchValue });
    }
  }, [searchValue]);

  return (
    <div className="category">
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        alertVariant="filled"
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        massage={SnackbarStore.massage}
      />
      <div className="heading">Category</div>
      <TwoBreadcrumb
        mainName="Category"
        mainLink="category"
        activeName="List"
      />
      <div className="btn-right-side flex">
        <Link to="/category/new">
          <Button variant="contained" className="btn" startIcon={<IoIosAdd />}>
            {/* <IoIosAdd className="icon" /> */}
            New Category
          </Button>
        </Link>
      </div>

      <Grid container sx={{ mt: 1 }}>
        <Grid item xs={10} sm={6} md={4} lg={3}>
          <FormControl fullWidth variant="standard">
            <InputLabel htmlFor="standard-adornment-search" value={searchValue}>
              <p style={{ fontWeight: 500 }}>Search Category Name</p>
            </InputLabel>
            <Input
              id="standard-adornment-search"
              value={searchValue}
              onChange={({ target: { value } }) => setSearchValue(value)}
              endAdornment={
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
        <Grid
          item
          xs={2}
          sm={6}
          md={8}
          lg={9}
          sx={{ margin: "auto", mt: "10px" }}
        >
          <Box
            sx={{
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                setSearchValue("");
              }}
            >
              <RestartAltIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <div className="main">
        <Grid container spacing={2}>
          {CategoryStore.category ? (
            CategoryStore.category.length ? (
              CategoryStore.category
                .slice()
                .reverse()
                .map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item._id}>
                    <CategoryCard
                      item={item}
                      isStatusLoading={isStatusLoading}
                      isLoadingItemId={isLoadingItemId}
                      switchOnChange={async () => {
                        setIsLoadingItemId(item._id);
                        setIsStatusLoading(true);
                        await CategoryStore.updateCategoryStatus({
                          _id: item._id,
                          status: item.status === "A" ? "U" : "A",
                        });
                        setIsStatusLoading(false);
                      }}
                    />
                  </Grid>
                ))
            ) : (
              <Grid item container>
                <Grid item xs={12}>
                  <div className="noData">No Data</div>
                </Grid>
              </Grid>
            )
          ) : (
            <div className="process">
              <CircularProgress className="cProgress" />
            </div>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default Category;
